import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import bannerImg from 'assets/wellbeing/AUTOCUIDAD-BANNER-TOP.webp';
import { HeroBanner } from 'components/HeroBanner';
import { TrainingCalendar } from 'components/TrainingCalendar';
import { Breadcrumb } from 'components/ui/Breadcrumb';
import { ROUTES } from 'constants/routes';
import { PastTrainingsSection } from './PastTrainingsSection';

export const TrainingsPage = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);

  return (
    <div className="flex flex-col gap-8">
      <Breadcrumb
        links={[
          { href: ROUTES.WELL_BEING, label: t('Nav.wellBeing', { ns: LOCIZE_NS.COMMON }) },
          {
            href: `${ROUTES.WELL_BEING}/trainings`,
            label: t('WellBeing.Categories.Trainings.heading'),
          },
        ]}
      />
      <HeroBanner image={bannerImg} alt={t('WellBeing.Categories.Trainings.heading')} />
      <Card className="border-0 p-4 am-md:p-6">
        <TrainingCalendar hideViewAllTrainings />
      </Card>
      <PastTrainingsSection />
    </div>
  );
};
